import axios from "axios";

export async function submitIdentityDetail({
  aadhar_number,
  pan_number,
  voter_id,
  passport_number,
  driving_license,
}) {
  return await axios.post("/api/employees/identity-details", {
    aadhar_number: aadhar_number ?? "",
    pan_number: pan_number ?? "",
    voter_id: voter_id ?? "",
    passport_number: passport_number ?? "",
    driving_license: driving_license ?? "",
  });
}

export async function submitJobDetailApi({
  department,
  designation,
  employee_id,
  location,
  date_of_joining,
  employee_type,
  work_location,
  reporting_manager_id,
}) {
  return await axios.post("/api/employees/job-details", {
    department,
    designation,
    employ_id: employee_id,
    location,
    date_of_joining,
    employee_type,
    work_location,
    reporting_manager_id,
  });
}

export async function submitHistoryApi(value) {
  const formData = new FormData();
  const fileFieldsByMode = {
    current: ["salary_slip", "offer_letter", "resignation_acceptance_letter"],
    previous: ["salary_slip", "relieving_letter", "experience_letter"],
  };

  const employmentHistory = Array.isArray(value)
    ? value
    : value
      ? [value]
      : [];
  const isFresher =
    employmentHistory.length === 1 &&
    employmentHistory[0]?.is_fresher === "true";

  const payload = isFresher
    ? { is_fresher: "true" }
    : employmentHistory.map((item) => ({
      organization_name: item.organization_name ?? "",
      designation: item.designation ?? "",
      from_date: item.from_date ?? null,
      to_date: (item.currently_working_here === true || item.currently_working_here === "true") ? "" : (item.to_date ?? ""),
      reason_for_leaving: item.reason_for_leaving ?? "",
      org_address: item.org_address ?? "",
      emp_id: item.emp_id ?? "",
      emp_status: item.emp_status ?? "",
      last_salary: item.last_salary ?? "",
      hr_manager_name: item.hr_manager_name ?? "",
      hr_manager_contact: item.hr_manager_contact ?? "",
      reporting_manager_name: item.reporting_manager_name ?? "",
      reporting_manager_contact: item.reporting_manager_contact ?? "",
      professional_reference_name: item.professional_reference_name ?? "",
      professional_reference_designation:
        item.professional_reference_designation ?? "",
      professional_reference_professional:
        item.professional_reference_professional ?? "",
      professional_reference_contact: item.professional_reference_contact ?? "",
      documents: {
        salary_slip: typeof item.salary_slip === "string" ? item.salary_slip : (item.salary_slip === null ? "" : (item.documents?.salary_slip || "")),
        relieving_letter: typeof item.relieving_letter === "string" ? item.relieving_letter : (item.relieving_letter === null ? "" : (item.documents?.relieving_letter || "")),
        experience_letter: typeof item.experience_letter === "string" ? item.experience_letter : (item.experience_letter === null ? "" : (item.documents?.experience_letter || "")),
        offer_letter: typeof item.offer_letter === "string" ? item.offer_letter : (item.offer_letter === null ? "" : (item.documents?.offer_letter || "")),
        resignation_acceptance_letter: typeof item.resignation_acceptance_letter === "string" ? item.resignation_acceptance_letter : (item.resignation_acceptance_letter === null ? "" : (item.documents?.resignation_acceptance_letter || "")),
      }
    }));

  formData.append("data", JSON.stringify(isFresher ? payload : { employment: payload || [] }));

  if (!isFresher) {
    employmentHistory.forEach((item, index) => {
      const mode = item.to_date ? "previous" : "current";
      fileFieldsByMode[mode].forEach((field) => {
        const file = item?.[field]?.originFileObj || item?.[field] || item?.documents?.[field];

        if (file instanceof File) {
          // Newly selected file — send the binary
          formData.append(`employment[${index}][${field}]`, file);
        }
      });
    });
  }

  return await axios.post("/api/employees/employment-history", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export async function submitRefferenceApi(value, hasRelative, relatives = []) {
  const payload = value?.map((item) => ({
    name: item.name,
    employee_code: item.employee_code,
    work_location: item.work_location,
    company_name: item.company_name,
    contact_number: item.contact_number,
  }));

  const relativePayload = hasRelative
    ? relatives
        .filter((item) => item?.relationship || item?.employee_code)
        .map((item) => ({
          employee_code: item.employee_code,
          relationship: item.relationship,
        }))
    : [];

  return await axios.post("/api/employees/reference-details", {
    references: payload,
    relative_declaration: hasRelative ? "yes" : "no",
    relative_details: relativePayload,
  });
}

export async function submitEsicDetailApi({
  is_covered,
  esic_number,
  dispensary_address,
}) {
  return await axios.post("/api/employees/esic-details", {
    is_covered,
    esic_number,
    dispensary_address,
  });
}

export async function submitPfDetailApi({
  uan_number,
  pf_transfer_required,
  pf_number,
}) {
  return await axios.post("/api/employees/pf-details", {
    uan_number,
    pf_transfer_required,
    pf_number: pf_number,
  });
}

export async function confirmOrRejectAppointment({ accept, reject, reason }) {
  return await axios.post("/api/employees/accept-reject", {
    accept,
    reject,
    reason,
  });
}
